import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="w-full flex flex-col lg:flex-row min-h-[500px]">
      <div className="relative w-full lg:w-1/2 min-h-[400px] lg:min-h-[600px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20flat%20lay%20with%20designer%20shoes%20scarves%20leather%20bags%20and%20perfume%20bottles%20scattered%20gracefully%20on%20soft%20cream%20linen%20fabric%20texture%20soft%20natural%20daylight%20from%20window%20gentle%20shadows%20editorial%20catalog%20style%20European%20luxury%20aesthetic%20minimal%20warm%20tones%20unboxing%20vibe&width=900&height=1200&seq=yoybuy-cta-bg-02&orientation=portrait"
          alt="Категории товаров"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        <div className="absolute bottom-8 left-8 md:bottom-12 md:left-12">
          <span className="text-xs font-label text-foreground-700 bg-background-50/80 px-3 py-1 rounded-full uppercase tracking-wider">Лучшие категории</span>
        </div>
      </div>

      <div className="w-full lg:w-1/2 flex flex-col items-center justify-center px-6 md:px-16 py-14 md:py-20 bg-background-50">
        <div className="max-w-lg text-center">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-3">
            Покупай Проще
          </h2>
          <h3 className="text-2xl md:text-3xl font-heading font-light text-foreground-600 italic mb-8">
            С YOYBUY Sheet
          </h3>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-10 max-w-md mx-auto">
            YOYBUY Spreadsheet — это удобная система таблиц, которая помогает экономить время и деньги при заказах из Китая. Сравнивайте цены, отслеживайте заказы и покупайте выгоднее с нашим инструментом.
          </p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-foreground-900 text-background-50 px-8 py-3.5 rounded-full text-base font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap"
          >
            buy it now
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}